import { CheckCircle2, CircleAlert, FileCode2, Layers3, LoaderCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { CreateJobForm } from "../features/svg-jobs/CreateJobForm";
import { JobList } from "../features/svg-jobs/JobList";
import { useAllSvgJobs } from "../features/svg-jobs/hooks";
import { isActive } from "../features/svg-jobs/status";

export function WorkspacePage() {
  const jobsQuery = useAllSvgJobs();
  const jobs = jobsQuery.data || [];
  const counts = {
    all: jobs.length,
    active: jobs.filter(isActive).length,
    completed: jobs.filter((job) => job.status === "completed").length,
    failed: jobs.filter((job) => ["failed", "cancelled", "expired"].includes(job.status)).length,
  };

  return (
    <div className="page-container" data-ui-capture="authenticated-workspace">
      <header className="page-header workspace-header">
        <div><span className="kicker">DIAGRAM WORKSPACE</span><h1>创建 SVG 绘图任务</h1><p>手动提交源码，实时查看 GitHub Actions 渲染进度。</p></div>
        <Link className="secondary-button" to="/jobs">查看全部任务</Link>
      </header>

      <section className="stats-grid" aria-label="任务概览">
        <article><span className="stat-icon"><Layers3 size={18} /></span><div><small>全部任务</small><strong>{counts.all}</strong></div></article>
        <article><span className="stat-icon active"><LoaderCircle className={counts.active ? "spin" : ""} size={18} /></span><div><small>进行中</small><strong>{counts.active}</strong></div></article>
        <article><span className="stat-icon success"><CheckCircle2 size={18} /></span><div><small>已完成</small><strong>{counts.completed}</strong></div></article>
        <article><span className="stat-icon danger"><CircleAlert size={18} /></span><div><small>异常</small><strong>{counts.failed}</strong></div></article>
      </section>

      <CreateJobForm />

      <section className="recent-section">
        <div className="section-heading"><div><span className="kicker">RECENT</span><h2>最近任务</h2><p>展示最近 5 条任务和当前阶段。</p></div><Link className="ghost-button" to="/jobs">全部任务</Link></div>
        <JobList jobs={jobs.slice(0, 5)} loading={jobsQuery.isLoading} emptyMessage="创建第一个 TikZ、PGFPlots、DOT 或 D2 任务" />
      </section>

      {jobsQuery.error && <div className="alert danger"><FileCode2 size={18} /><span>{jobsQuery.error instanceof Error ? jobsQuery.error.message : "任务加载失败"}</span></div>}
    </div>
  );
}
